<template>
  <div class="shareTicketPopUp" v-if="tktShare.tickets.length != 0">
    <div class="bg" @click="resetTicketsForShare"></div>
    <div class="body_pop_up">
      <div class="head_section">
        <div class="inner_wrap">
          <p>Отправить билет</p>
          <span class="closePopUp" @click="resetTicketsForShare">
            <img src="../../assets/img/icons/menu_close.svg" alt="close">
          </span>
        </div>
      </div>
      <div class="body_section">
        <div class="inner_wrap">
          <div class="ticket_text" v-if="step == 0">
            <table>
              <tbody>
                <tr>
                  <th>Ряд:</th>
                  <th>Место:</th>
                  <th>Введите E-mail:</th>
                </tr>
                <tr v-for="tkt in tktShare.tickets">
                  <td>{{ tkt.row }}</td>
                  <td>{{ tkt.place }}</td>
                  <td>
                    <input type="text" v-model="tkt.receiver">
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="submit" @click.prevent="submit">Отправить</button>
          </div>
          <div id="sharedThx" class="sharedThx"  v-if="step == 1">
            <div class="sharedThxPage">
              <div class="img"></div>
              <p>Билеты отправлены!</p>
              <a href="index.html" @click.prevent="resetTicketsForShare">на Главную</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Store from '../../store'
  export default {
    data: function () {
      return {
        step: 0
      }
    },
    computed: {
      tktShare: function () {
        return Store.state.tktShare
      }
    },
    methods: {
      resetTicketsForShare: function () {
        Store.commit('resetTicketsForShare')
        this.step = 0
      },
      submit: function () {
        var sharings = []
        for (var i = 0, x = this.tktShare.tickets.length; i < x; i++) {
          if (this.tktShare.tickets[i].receiver) {
            sharings.push(this.tktShare.tickets[i])
          }
        }
        this.$http.post('/api/share_tickets', {data: JSON.stringify(sharings)}).then(response => {
          if (!response.body.err) {
            this.step = 1
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// share-tickets.vue?2ebc399c